/**
* DevExpress Dashboard (group-item.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { ModelSerializer } from '@devexpress/analytics-core/analytics-utils';
import { itemTypesMap } from '../../serializable-model';
import { DashboardItem } from '../dashboard-item';
import { groupItemSerializationInfo } from './metadata/_group-item';
export class GroupItem extends DashboardItem {
    constructor(dashboardItemJSON = {}, serializer = new ModelSerializer()) {
        super(dashboardItemJSON, serializer);
    }
    _getInfoCore() {
        return groupItemSerializationInfo;
    }
    _getDefaultItemType() {
        return 'Group';
    }
}
itemTypesMap['Group'] = { type: GroupItem, groupName: 'layout', title: 'DashboardStringId.DefaultNameItemGroup', index: 25 };
